import { useEffect } from 'react';
import { Link } from 'wouter';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  url: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  useEffect(() => {
    // Add breadcrumb schema markup to head
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': items.map((item, index) => ({
        '@type': 'ListItem',
        'position': index + 1,
        'name': item.label,
        'item': `https://danispainting.net${item.url}`
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [items]);

  return (
    <nav className="flex flex-wrap items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-600 px-1">
      {items.map((item, index) => (
        <div key={item.url} className="flex items-center gap-1.5 sm:gap-2">
          {index > 0 && <ChevronRight size={14} className="text-gray-400 flex-shrink-0" />}
          {index === items.length - 1 ? (
            <span className="text-gray-900 font-medium break-words">{item.label}</span>
          ) : (
            <Link href={item.url} className="text-[#4caf30] hover:text-[#3d9426] transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
